/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Is_RequiredInputs */

const en_field_is_required = /** @type {(inputs: Field_Is_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This field is required`)
};

const nl_field_is_required = /** @type {(inputs: Field_Is_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit veld is verplicht`)
};

/**
* | output |
* | --- |
* | "This field is required" |
*
* @param {Field_Is_RequiredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const field_is_required = /** @type {((inputs?: Field_Is_RequiredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Is_RequiredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_field_is_required(inputs)
	return en_field_is_required(inputs)
});